import "./Education.css";
import Data from "./Data";
import Card from "../experience/Card";

const Experience = () => {
  return (
    <section className="education container section" id="education">
      <h2 className="section__title">
        Education
      </h2>

      <div className="education__container grid">
        <div className="timeline grid">
          {Data.map((val, id) => {
            if (val.category === "first-col") {
              return (
                <Card
                  key={id}
                  icon={val.icon} 
                  title={val.title}
                  duration={val.time}
                  description={val.desc}
                />
              )
            };

            return null;
          })}
        </div>
        
        <div className="timeline grid">
          {Data.map((val, id) => {
            if (val.category === "second-col") {
              return (
                <Card
                  key={id}
                  icon={val.icon} 
                  title={val.title}
                  duration={val.time}
                  description={val.desc}
                />
              )
            };

            return null;
          })}
        </div>
      </div>
    </section>
  )
}

export default Experience